import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AmountButton from '../AmountButton';
import FrequencyButton from '../FrequencyButton';
import {Field} from '@nexios/frontend-forms';
import styled, {withTheme} from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  row-gap: ${props => props.layout?.rowGap || '20px'};

  div {
    justify-content: ${props => props.layout?.justifyContent || 'space-around'};
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: ${props => props.layout?.justifyContent || 'space-around'};
`;

export const SingleRow = styled.div`
  display: flex;
  gap: ${props => props.layout?.gap || '20px'};
  && {
    justify-content: ${props => props.layout?.justifyContent || 'space-between'};
  }

  button {
    width: ${props => (props.layout || {})['width' + props.buttons + 'Buttons']};
  }
`;

export const Center = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;

  button {
    width: ${props => props.layout?.width || '94px'};
  }
`;

class ButtonContainer extends Component {
  static propTypes = {
    list: PropTypes.array.isRequired
  };

  render () {
    if (this.props.list === undefined) {
      return null;
    }

    const isFrequency = this.props.fieldName === 'frequency';
    const ButtonComponent = isFrequency ? FrequencyButton : AmountButton;

    const layout = (isFrequency
      ? this.props.theme?.frequencyButtonContainer
      : this.props.theme?.buttonContainerSpaceBetween) || {};

    const listItems = this.props.list.map((item, indx) => <Field name={item.fieldName || this.props.fieldName} key={indx} component={
      ({setValue, validate, value: currentSelectedValue}) => <ButtonComponent
        isChecked={currentSelectedValue === item.value}
        label={item.label}
        value={item.value}
        ribbon={item.ribbon}
        icon={item.icon}
        title={item.title}
        validate={validate}
        setValue={setValue} />
    } />);

    if (listItems.length === 1) {
      return <Center>
        {listItems}
      </Center>;
    }

    if (layout.singleRow) {
      if (listItems.length === 5) {
        return <MainContainer layout={layout}>
          <SingleRow layout={layout} buttons={'2'}>{listItems[0]}{listItems[1]}</SingleRow>
          <SingleRow layout={layout} buttons={'3'}>{listItems[2]}{listItems[3]}{listItems[4]}</SingleRow>
        </MainContainer>;
      }

      return <SingleRow layout={layout} buttons={listItems.length + ''}>{listItems}</SingleRow>;
    }

    if (listItems.length === 3) {
      return <SpaceBetween layout={layout}>
        {listItems}
      </SpaceBetween>;
    } else if (listItems.length === 4) {
      return <MainContainer layout={layout}>
        <Container layout={layout}>{listItems[0]}{listItems[1]}</Container>
        <Container layout={layout}>{listItems[2]}{listItems[3]}</Container>
      </MainContainer>;
    } else if (listItems.length === 5) {
      return <MainContainer layout={layout}>
        <Container layout={layout}>{listItems[0]}{listItems[1]}</Container>
        <Container layout={layout}>{listItems[2]}{listItems[3]}{listItems[4]}</Container>
      </MainContainer>;
    } else {
      return <Container layout={layout}>
        {listItems}
      </Container>;
    }
  }
}

export default withTheme(ButtonContainer);
